module.exports = __webpack_public_path__ + "media/images/proefdeperfectie_usp-a27d91c179b4937e37c5bb583f02c010.jpg";